import styled, { keyframes } from "styled-components";
import { theme } from "ui/themes";

const showMoreSoftly = keyframes`
  from {
    opacity: 0;
    top: 26px;
  }
  to {
    opacity: 1;
    top: 30px;
  }
`;

export const Container = styled.div`
  width: fit-content;
  display: flex;
  position: relative;
  z-index: 2;

  @media ${theme.device.desktopFirst.mobileL} {
    margin-bottom: 2rem;
  }
`;

export const ViewMore = styled.div`
  display: flex;
  font-size: 1.2rem;
  font-weight: ${theme.typography.fontWeight["500"]};
  cursor: pointer;
  user-select: none;
  text-decoration: underline;
  color: ${theme.colors.neutral["670"]};
  font-size: 1.125rem;
`;

interface ModalProps {
  isVisibled: boolean;
}

export const Modal = styled.div<ModalProps>`
  background-color: ${theme.colors.neutral.white};
  display: ${({ isVisibled }) => (isVisibled ? "block" : "none")};
  box-shadow: 0 4px 12px 0 rgb(35 35 35 / 20%);
  padding: 0.8rem 0.7rem;
  font-weight: ${theme.typography.fontWeight["200"]};
  border-radius: 8px !important;
  width: max-content;

  position: absolute;
  z-index: 7;

  top: 30px;
  left: -90%;
  animation: ${showMoreSoftly} 0.2s ease-in;

  @media ${theme.device.desktopFirst.tablet} {
    left: -20%;
  }

  @media ${theme.device.desktopFirst.tabletS} {
    left: -10%;
  }
`;

export const ModalArrow = styled.div`
  background-color: ${theme.colors.neutral.white};
  height: 0.9rem;
  width: 0.9rem;
  position: absolute;
  top: -6px;
  left: 45%;
  border-top: 0.05rem solid rgb(35 35 35 / 20%);
  border-right: 0.05rem solid rgb(35 35 35 / 20%);
  transform: rotate(-45deg);

  @media ${theme.device.desktopFirst.tablet} {
    left: 22.5%;
  }

  @media ${theme.device.desktopFirst.tabletS} {
    left: 20%;
  }
`;

export const ParcelPrice = styled.p`
  margin-top: 0.2rem;
  font-size: 1rem;
  padding-bottom: 0.2rem;
  font-weight: ${theme.typography.fontWeight["500"]};
`;
